document.addEventListener("DOMContentLoaded", function () {
  const initialViewInterval = setInterval(function () {
    var element = document.querySelector('.ais-results-as-block');
    if (element) {
      element.classList.remove('ais-results-as-block');
      element.classList.add('ais-results-as-list');
      clearInterval(initialViewInterval);
    } else {
      // console.log("Element with class 'ais-results-as-block' not found.");
    }
  }, 200);
});

document.addEventListener('algolia.hooks.initialize', function () {
  // Global variable to track current view mode
  window.algoliaViewMode = 'products';

  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function (_defaultTemplate, data, html) {
    return html`
      <div class="ais-page">
        <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="content-button-search">
          <span class="active" data-view="products">Products (<span class="ais-products-count">0</span>)</span>
          <span data-view="categories">Categories (<span class="ais-categories-count">0</span>)</span>
       </div>
        <div class="ais-facets-button">
          Show filters
        </div>
        <div class="ais-facets">
         <h2 class="title-filter">
            Filter by:
          </h2>
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${data.facets.map(
      facet =>
        html`
                <div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}" >
                  <label for="${facet.escapedName}" class="ais-range-slider--header ais-facet--header ais-header">
                    ${facet.title}
                  </label>
                  <input class="ais-dropdown-checkbox" type="checkbox" id="${facet.escapedName}" name="dropdown" />
                  <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
                </div>
              `
    )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1664 1450"><path d="M768 512v-384q0-52-38-90t-90-38h-512q-52 0-90 38t-38 90v384q0 52 38 90t90 38h512q52 0 90-38t38-90zM768 1280v-384q0-52-38-90t-90-38h-512q-52 0-90 38t-38 90v384q0 52 38 90t90 38h512q52 0 90-38t38-90zM1664 512v-384q0-52-38-90t-90-38h-512q-52 0-90 38t-38 90v384q0 52 38 90t90 38h512q52 0 90-38t38-90zM1664 1280v-384q0-52-38-90t-90-38h-512q-52 0-90 38t-38 90v384q0 52 38 90t90 38h512q52 0 90-38t38-90z"></path></svg>
              </span>
              <span class="ais-change-display-list">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1792 1450"><path d="M512 288v-192q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v192q0 40 28 68t68 28h320q40 0 68-28t28-68zM512 800v-192q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v192q0 40 28 68t68 28h320q40 0 68-28t28-68zM1792 288v-192q0-40-28-68t-68-28h-960q-40 0-68 28t-28 68v192q0 40 28 68t68 28h960q40 0 68-28t28-68zM512 1312v-192q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v192q0 40 28 68t68 28h320q40 0 68-28t28-68zM1792 800v-192q0-40-28-68t-68-28h-960q-40 0-68 28t-28 68v192q0 40 28 68t68 28h960q40 0 68-28t28-68zM1792 1312v-192q0-40-28-68t-68-28h-960q-40 0-68 28t-28 68v192q0 40 28 68t68 28h960q40 0 68-28t28-68z"></path></svg>
              </span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
        ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
        : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
          <div class="ais-collections-container" style="display: none;"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  });

  const yotpoInterval = setInterval(() => {
    if (window.yotpo && window.yotpo.initWidgets) {
      // console.log('Initializing Yotpo...'); // Verify that Yotpo is being initialized
      window.yotpo.initWidgets();
      clearInterval(yotpoInterval);
    }
  }, 1000);

  let checkResultsInterval = setInterval(() => {
    if (algoliaShopify.instantsearch && algoliaShopify.instantsearch.search.helper && algoliaShopify.instantsearch.search.helper.lastResults) {
      const results = algoliaShopify.instantsearch.search.helper.lastResults;

      const productsCount = results?.nbHits || 0;
      const productsElement = document.querySelector('.ais-products-count');
      if (productsElement) productsElement.textContent = productsCount;

      // Get collections count from Algolia
      fetchCollectionsCount(algoliaShopify.instantsearch.search.helper.state.query);

      clearInterval(checkResultsInterval);
    }
  }, 100);

  // Add event listeners for the toggle buttons
  const toggleButtonsInterval = setInterval(() => {
    const contentButtonSearch = document.querySelector('.content-button-search');
    if (contentButtonSearch) {
      contentButtonSearch.addEventListener('click', (event) => {
        const clickedSpan = event.target.closest('span[data-view]');
        if (clickedSpan) {
          const viewMode = clickedSpan.getAttribute('data-view');

          // Update active class
          document.querySelectorAll('.content-button-search > span').forEach(span => {
            span.classList.remove('active');
          });
          clickedSpan.classList.add('active');

          // Toggle visibility of containers
          const hitsContainer = document.querySelector('.ais-hits-container');
          const collectionsContainer = document.querySelector('.ais-collections-container');
          const paginationContainer = document.querySelector('.ais-pagination-container');

          if (viewMode === 'products') {
            window.algoliaViewMode = 'products';
            hitsContainer.style.display = '';
            collectionsContainer.style.display = 'none';

            // Show pagination for products
            if (paginationContainer) {
              paginationContainer.style.display = '';

              // Reset pagination to the first page
              const firstPageButton = paginationContainer.querySelector('.ais-pagination--item__first a');
              if (firstPageButton) {
                firstPageButton.click();
              } else {
                // If there's no first page button, try with the first item
                const firstPageItem = paginationContainer.querySelector('.ais-pagination--item a');
                if (firstPageItem) {
                  firstPageItem.click();
                }
              }
            }
          } else if (viewMode === 'categories') {
            window.algoliaViewMode = 'categories';
            hitsContainer.style.display = 'none';
            collectionsContainer.style.display = '';

            // Hide pagination for categories
            if (paginationContainer) {
              paginationContainer.style.display = 'none';
            }

            // Fetch collections if they haven't been loaded yet
            if (collectionsContainer.innerHTML.trim() === '') {
              fetchCollections(algoliaShopify.instantsearch.search.helper.state.query);
            }
          }
        }
      });

      clearInterval(toggleButtonsInterval);
    }
  }, 100);

  // FUNCTION FOR BUG SOLUTION-----------------------------------------------------------
  function scrollToTop() {
    console.log('[Scroll Fix] Scrolling to the top');
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }

  const filtersSetupInterval = setInterval(() => {
    const openedFilters = new Map();
    document.addEventListener('click', function (e) {
      const headerElement = e.target.closest('.ais-range-slider--header, .ais-facet--header, .ais-header');
      if (headerElement) {
        const filterId = headerElement.textContent.trim() || headerElement.getAttribute('for');

        openedFilters.set(filterId, true);

        const optionsSetupInterval = setInterval(() => {
          const parentContainer = headerElement.closest('.ais-facet-dropdown-wrapper');
          if (parentContainer) {
            const optionLabels = parentContainer.querySelectorAll('.ais-RefinementList-label, .ais-facet--label');

            optionLabels.forEach(label => {
              if (!label._hasScrollListener) {
                label.addEventListener('click', function () {
                  scrollToTop();
                });
                label._hasScrollListener = true;
              }
            });
            const refinedValueLinks = parentContainer.querySelectorAll('.ais-current-refined-values--link');

            refinedValueLinks.forEach(link => {
              if (!link._hasScrollListener) {
                link.addEventListener('click', function () {
                  scrollToTop();
                });
                link._hasScrollListener = true;
              }
            });

            clearInterval(optionsSetupInterval);
          }
        }, 50);
      }

      const labelElement = e.target.closest('.ais-RefinementList-label, .ais-facet--label');

      if (labelElement && !labelElement._hasScrollListener) {
        labelElement.addEventListener('click', function () {
          scrollToTop();
        });
        labelElement._hasScrollListener = true;
      }

      const refinedValueLink = e.target.closest('.ais-current-refined-values--link');

      if (refinedValueLink && !refinedValueLink._hasScrollListener) {
        refinedValueLink.addEventListener('click', function () {
          scrollToTop();
        });
        refinedValueLink._hasScrollListener = true;
      }
    });

    const initialRefinedValueLinks = document.querySelectorAll('.ais-current-refined-values--link');
    if (initialRefinedValueLinks.length > 0) {

      initialRefinedValueLinks.forEach(link => {
        if (!link._hasScrollListener) {
          link.addEventListener('click', function () {
            scrollToTop();
          });
          link._hasScrollListener = true;
        }
      });
    }

    clearInterval(filtersSetupInterval);
  }, 300);

  //-----------------------------------------------------------

  // Function to fetch collections via AJAX
  function fetchCollections(query) {
    if (!query) return;

    const collectionsContainer = document.querySelector('.ais-collections-container');
    collectionsContainer.innerHTML = '<div class="loading-collections">Loading collections...</div>';

    // Construct the Algolia API URL
    const appId = algoliaShopify.config.app_id;
    const apiKey = algoliaShopify.config.search_api_key;

    // Instead of using a separate collections index, we'll try to use the main products index
    // and filter by record_type if available, or use Shopify's API as a fallback
    const mainIndexName = algoliaShopify.config.index_prefix;

    // console.log('Fetching collections with query:', query);
    // console.log('Using main index:', mainIndexName);

    // First, try to get all available indices to see what we're working with
    fetch(`https://${appId}-dsn.algolia.net/1/indexes`, {
      method: 'GET',
      headers: {
        'X-Algolia-API-Key': apiKey,
        'X-Algolia-Application-Id': appId
      }
    })
      .then(response => response.json())
      .then(indexData => {
        // console.log('Available Algolia indices:', indexData);
        const indices = indexData.items || [];

        // Look for any index that might contain collections
        const possibleCollectionIndices = indices.filter(index =>
          index.name.toLowerCase().includes('collection') ||
          index.name.toLowerCase().includes('categoria')
        );

        if (possibleCollectionIndices.length > 0) {
          // console.log('Possible collection indices found:', possibleCollectionIndices);
          // Use the first matching index
          const collectionIndexName = possibleCollectionIndices[0].name;
          fetchFromAlgoliaIndex(collectionIndexName);
        } else {
          // Try using the main index with filters if no collection-specific index exists
          // console.log('No collection indices found, trying main index with filters');
          fetchFromMainIndex();
        }
      })
      .catch(error => {
        // console.error('Error checking available indices:', error);
        // Fallback to Shopify API
        fetchFromShopifyAPI();
      });

    // Function to fetch from a specific Algolia index
    function fetchFromAlgoliaIndex(indexName) {
      fetch(`https://${appId}-dsn.algolia.net/1/indexes/${indexName}/query`, {
        method: 'POST',
        headers: {
          'X-Algolia-API-Key': apiKey,
          'X-Algolia-Application-Id': appId,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          query: query,
          hitsPerPage: 20
        })
      })
        .then(response => response.json())
        .then(data => {
          // console.log('Collections API response:', data);
          const collections = data.hits || [];

          // Update collections count
          const categoriesElement = document.querySelector('.ais-categories-count');
          if (categoriesElement) categoriesElement.textContent = collections.length;

          renderCollections(collections);
        })
        .catch(error => {
          // console.error('Error fetching from collection index:', error);
          fetchFromShopifyAPI();
        });
    }

    // Function to fetch from main index with filters
    function fetchFromMainIndex() {
      fetch(`https://${appId}-dsn.algolia.net/1/indexes/${mainIndexName}/query`, {
        method: 'POST',
        headers: {
          'X-Algolia-API-Key': apiKey,
          'X-Algolia-Application-Id': appId,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          query: query,
          filters: 'record_type:collection OR object_type:collection',
          hitsPerPage: 20
        })
      })
        .then(response => response.json())
        .then(data => {
          // console.log('Main index filtered response:', data);
          const collections = data.hits || [];

          if (collections.length > 0) {
            // Update collections count
            const categoriesElement = document.querySelector('.ais-categories-count');
            if (categoriesElement) categoriesElement.textContent = collections.length;

            renderCollections(collections);
          } else {
            // If no collections found with filter, try Shopify API
            fetchFromShopifyAPI();
          }
        })
        .catch(error => {
          // console.error('Error fetching from main index with filters:', error);
          fetchFromShopifyAPI();
        });
    }

    // Function to fetch from Shopify API as a fallback
    function fetchFromShopifyAPI() {
      // console.log('Falling back to Shopify API');

      // Use Shopify's predictive search API
      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=collection`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(response => response.json())
        .then(data => {
          // console.log('Shopify API response:', data);
          const collections = data.resources.collections || [];
          const count = collections.length;

          if (count > 0) {
            const categoriesElement = document.querySelector('.ais-categories-count');
            if (categoriesElement) categoriesElement.textContent = count;

            if (collections.length > 0) {
              renderCollections(collections, true);
            } else {
              // If no specific collections found for this search, get popular or related collections
              // console.log('No specific collections found, getting popular collections instead');
              fetchPopularCollections();
            }
          } else {
            // If no specific collections found for this search, get popular or related collections
            // console.log('No specific collections found, getting popular collections instead');
            fetchPopularCollections();
          }
        })
        .catch(error => {
          // console.error('Error fetching from Shopify API:', error);
          fetchPopularCollections();
        });
    }

    // Function to fetch popular collections when no specific results are found
    function fetchPopularCollections() {
      // Get all available collections
      fetch('/collections.json', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(response => response.json())
        .then(data => {
          // console.log('All collections response:', data);
          let collections = data.collections || [];

          // Filter collections that may be related to the query
          // or simply show no collections if there are no matches
          if (query && query.length > 2) {
            const queryTerms = query.toLowerCase().split(' ');
            const filteredCollections = collections.filter(collection => {
              const title = (collection.title || '').toLowerCase();
              const body = (collection.body_html || '').toLowerCase();
              return queryTerms.some(term =>
                title.includes(term) || body.includes(term)
              );
            });

            // If we find at least some related collections, use them
            if (filteredCollections.length > 0) {
              collections = filteredCollections;
              // console.log('Found related collections:', collections.length);
            } else {
              // console.log('No related collections found, showing no collections');
              collections = []; // Don't show collections if none are relevant
            }
          } else {
            // If the query is too short, don't show collections
            collections = [];
          }

          // Update the counter
          const categoriesElement = document.querySelector('.ais-categories-count');
          if (categoriesElement) categoriesElement.textContent = collections.length;

          if (collections.length > 0) {
            renderCollections(collections, true);
          } else {
            collectionsContainer.innerHTML = '<div class="no-collections-found">No collections found matching your search.</div>';
          }
        })
        .catch(error => {
          // console.error('Error fetching popular collections:', error);
          collectionsContainer.innerHTML = '<div class="error-loading-collections">Error loading collections. Please try again.</div>';

          // Set count to 0 if all methods fail
          const categoriesElement = document.querySelector('.ais-categories-count');
          if (categoriesElement) categoriesElement.textContent = '0';
        });
    }

    // Function to render collections in the UI
    function renderCollections(collections, isFromShopify = false) {
      if (collections.length > 0) {
        let html = '<div class="ais-collections-list">';

        collections.forEach(collection => {
          // Handle different data structures based on source
          let title, handle, image, description;

          if (isFromShopify) {
            title = collection.title || '';
            handle = collection.handle || '';
            description = collection.body || '';
            // Try to get the image from different properties
            image = collection.featured_image?.url ||
              collection.image?.src ||
              (collection.image && typeof collection.image === 'string' ? collection.image : '');
          } else {
            title = collection.title || collection.name || '';
            handle = collection.handle || '';
            description = collection.body_html || collection.description || collection.body || '';
            image = collection.image_url || collection.featured_image ||
              (collection.image && collection.image.src) ||
              collection.image || '';
          }

          // Limit the description length and remove HTML tags
          let cleanDescription = '';
          if (description) {
            // Remove HTML tags
            cleanDescription = description.replace(/<[^>]*>/g, ' ');
            // Limit to 150 characters and add ellipsis if needed
            if (cleanDescription.length > 150) {
              cleanDescription = cleanDescription.substring(0, 150) + '...';
            }
          }

          // Highlight search query in title
          let highlightedTitle = title;
          if (query && query.length > 1) {
            const queryTerms = query.toLowerCase().split(' ');
            queryTerms.forEach(term => {
              if (term.length > 1) { // Only highlight terms with at least 2 characters
                const regex = new RegExp(`(${term})`, 'gi');
                highlightedTitle = highlightedTitle.replace(regex, '<strong>$1</strong>');
              }
            });
          }

          const url = `/collections/${handle}`;

          // console.log('Collection found:', { title, handle, image, description: cleanDescription });

          html += `
            <div class="ais-collection-item">
              <a href="${url}" class="ais-collection-link">
                <div class="ais-collection-content">
                  <div class="ais-collection-details">
                    <div class="ais-collection-title">${highlightedTitle}</div>
                    ${cleanDescription ? `<div class="ais-collection-description">${cleanDescription}</div>` : ''}
                    <div class="ais-collection-view-button ais-hit--cart-button">View Collection</div>
                  </div>
                </div>
              </a>
            </div>
          `;
        });

        html += '</div>';
        collectionsContainer.innerHTML = html;
      } else {
        // console.log('No collections found for query:', query);
        collectionsContainer.innerHTML = '<div class="no-collections-found">No collections found matching your search.</div>';
      }
    }
  }

  // Function to fetch just the collections count
  function fetchCollectionsCount(query) {
    if (!query) {
      const categoriesElement = document.querySelector('.ais-categories-count');
      if (categoriesElement) categoriesElement.textContent = '0';
      return;
    }

    const appId = algoliaShopify.config.app_id;
    const apiKey = algoliaShopify.config.search_api_key;
    const mainIndexName = algoliaShopify.config.index_prefix;

    // console.log('Fetching collections count with query:', query);

    // Try to get count from Shopify API
    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=collection`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        // console.log('Shopify API count response:', data);
        const collections = data.resources.collections || [];
        const count = collections.length;

        if (count > 0) {
          const categoriesElement = document.querySelector('.ais-categories-count');
          if (categoriesElement) categoriesElement.textContent = count;
        } else {
          // If no specific collections found, get popular collections count
          fetchPopularCollectionsCount();
        }
      })
      .catch(error => {
        // console.error('Error fetching collections count from Shopify:', error);
        fetchPopularCollectionsCount();
      });

    // Function to fetch popular collections count
    function fetchPopularCollectionsCount() {
      // Get all available collections
      fetch('/collections.json', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(response => response.json())
        .then(data => {
          // console.log('All collections count response:', data);
          let collections = data.collections || [];

          // Filter collections that may be related to the query
          if (query && query.length > 2) {
            const queryTerms = query.toLowerCase().split(' ');
            const filteredCollections = collections.filter(collection => {
              const title = (collection.title || '').toLowerCase();
              const body = (collection.body_html || '').toLowerCase();
              return queryTerms.some(term =>
                title.includes(term) || body.includes(term)
              );
            });

            // If we find at least some related collections, use them for the count
            if (filteredCollections.length > 0) {
              collections = filteredCollections;
            } else {
              // If no related collections found, show 0
              collections = [];
            }
          } else {
            // If the query is too short, don't show collections
            collections = [];
          }

          // Update the counter
          const categoriesElement = document.querySelector('.ais-categories-count');
          if (categoriesElement) categoriesElement.textContent = collections.length;
        })
        .catch(error => {
          // console.error('Error fetching popular collections count:', error);

          // Fallback to Algolia as a last resort
          fallbackToAlgoliaCount();
        });
    }

    // Last resort: try with Algolia
    function fallbackToAlgoliaCount() {
      fetch(`https://${appId}-dsn.algolia.net/1/indexes/${mainIndexName}/query`, {
        method: 'POST',
        headers: {
          'X-Algolia-API-Key': apiKey,
          'X-Algolia-Application-Id': appId,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          query: query,
          filters: 'record_type:collection OR object_type:collection',
          hitsPerPage: 0
        })
      })
        .then(response => response.json())
        .then(data => {
          // console.log('Algolia count response:', data);
          const count = data.nbHits || 0;

          const categoriesElement = document.querySelector('.ais-categories-count');
          if (categoriesElement) categoriesElement.textContent = count;
        })
        .catch(error => {
          // console.error('Error fetching collections count from Algolia:', error);
          const categoriesElement = document.querySelector('.ais-categories-count');
          if (categoriesElement) categoriesElement.textContent = '0';
        });
    }
  }

  algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function (_defaultTemplate, templateOptions, elements, displaySuggestions) {
    const { html } = templateOptions;
    // Don't return the default template and return a custom two-column layout instead
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <div class="aa-PanelSections">
          <div class="aa-PanelSection--left">
            ${displaySuggestions &&
      html`
                <div class="aa-SourceHeader">
                  <span class="aa-SourceHeaderTitle">Popular Searches</span>
                  <div class="aa-SourceHeaderLine" />
                </div>
                ${elements.querySuggestionsPlugin}
              `}
            ${elements.collections} ${elements.articles} ${elements.pages}
            ${elements.redirectUrlPlugin}
          </div>
          <div class="aa-PanelSection--right">
            ${elements.products}
          </div>
        </div>
      </div>
    `;
  });


  algoliaShopify.hooks.registerHook('beforeAutocompleteHeaderTemplate', function (_defaultTemplate, templateOptions, resource) {
    const { html, state } = templateOptions;
    return html`
      <div class="aa-SourceHeader">
        <span class="aa-SourceHeaderTitle">
          ${resource == "Products" ? "Best Sellers" : algoliaShopify.translation_helpers.render_title(resource, state.query)}
        </span>
        <div class="aa-SourceHeaderLine" />
      </div>
    `;
  });
});


document.addEventListener('algolia.hooks.initialize', function () {

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      // Modify default options, then return them
      const { html, item, components } = templateOptions;
      return html`
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem"
      onClick="${() => trackSearchAttribution(item)}"
    >
      <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img
            src="${algoliaShopify.helpers.renderImage(item, 125).src}"
            srcset="${algoliaShopify.helpers.renderImage(item, 125).srcset}"
            sizes="${algoliaShopify.helpers.renderImage(item, 125).sizes}"
            alt="${item.title}"
          />
        </div>
        <div class="aa-ItemContentBody">
          <div class="aa-ItemContentBrand">
              ${components.Highlight({ hit: item, attribute: "title" })}
              <span class="algolia-variant">
                ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
              </span>
          </div>
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">
              ${
                item.product_type &&
                components.Highlight({ hit: item, attribute: "product_type" })
              }
            </div>
          </div>
          <div class="aa-ItemContentPrice">
            <div class="aa-ItemContentPriceCurrent">
              ${algoliaShopify.helpers.displayPrice(item, distinct)}
            </div>
          </div>
        </div>
      </div>
    </a>
  `;
    }
  );
  

  algoliaShopify.hooks.registerHook('beforeAutocompleteFooterTemplate', function (_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;
    return html`
      <div class="aa-footer" style="display: flex; align-items: center;" >
        <a class="aa-SeeAllBtn" href="${window.Shopify.routes.root}search?q=${state.query}" >
          View All Results (${algoliaShopify.helpers.formatNumber(state.context.nbProducts)})
        </a>
      </div>
    `;
  });
});

// Add CSS for collections display
document.addEventListener('DOMContentLoaded', () => {
  const style = document.createElement('style');
  style.textContent = `
    .content-button-search {
      display: flex;
      gap: 20px;
      margin-bottom: 20px;
    }
    
    .content-button-search span {
      cursor: pointer;
      padding: 5px 10px;
      border-radius: 4px;
    }
    
    .content-button-search span.active {
      font-weight: bold;
      color: #000;
      background-color: rgba(0, 0, 0, 0.05);
    }
    
    .ais-collections-list {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
    
    .ais-collection-item {
      border: 1px solid #e8e8e8;
      border-radius: 8px;
      overflow: hidden;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
    }
    
    .ais-collection-item:hover {
      transform: translateY(-5px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    }
    
    .ais-collection-link {
      display: block;
      text-decoration: none;
      color: inherit;
    }
    
    .ais-collection-content {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 20px !important;
    }
    
    .ais-collection-image-container {
      width: 100px;
      height: 100px;
      overflow: hidden;
      margin-right: 20px;
    }
    
    .ais-collection-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
    }
    
    .ais-collection-item:hover .ais-collection-image {
      transform: scale(1.05);
    }
    
    .ais-collection-details {
      flex-grow: 1;
    }
    
    .ais-collection-title {
      font-weight: 500;
      margin-bottom: 10px;
    }
    
    .ais-collection-description {
      font-size: 14px;
      color: #666;
      margin-bottom: 10px;
    }
    
    .ais-collection-view-button {
      background-color: #5d7189 !important;
      color: #fff !important;
      font-weight: 600 !important;
      border-right: 0 !important;
      padding: 8px 16px !important;
      cursor: pointer;
      float: right;
    }
    
    .loading-collections,
    .no-collections-found,
    .error-loading-collections {
      padding: 30px;
      text-align: center;
      color: #666;
    }
  `;
  document.head.appendChild(style);
});